import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';
import type { InventoryQueryLinkerSchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory';

import { useGetInventoriesMutation } from '../apis';

export function InventoryCombo({
  disabled,
  shouldOpenInNewTab = false,
  ...props
}: FormAsyncComboboxProps<InventoryQueryLinkerSchema> & { shouldOpenInNewTab?: boolean }) {
  const getName = useCallback(
    (item?: InventoryQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.primary_sku + ' - ' + item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink
          to="/inventory/$id"
          target={shouldOpenInNewTab ? '_blank' : undefined}
          params={{ id: `${item.id}` }}
          state={{ naturalBack: true }}
        >
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled, shouldOpenInNewTab]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetInventoriesMutation}
      disabled={disabled}
    />
  );
}
